import React from "react";
import { Tooltip } from "@mui/material";
import styled from "styled-components";
import { GfImageTag } from "@swagger/typescript-fetch-goflyer";

const Overlay = styled.div`
  position: absolute;
  top: 4px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  gap: 2px;
  flex-wrap: wrap;
  padding: 0 4px;
  z-index: 2;
`;

const TagIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
`;

const TagBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 3px;
  font-size: 11px;
  line-height: 1;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
`;

const getTagShortLabel = (name: string): string => {
  const firstToken = name.trim().split(/\s+/)[0] ?? name;
  return firstToken.length <= 6 ? firstToken : firstToken.slice(0, 2);
};

interface Props {
  imageTags?: GfImageTag[];
  dataTestId?: string;
}

export function ImageTagsOverlay({ imageTags, dataTestId }: Props) {
  const tags = imageTags?.filter((tag) => !tag.isDeleted) ?? [];

  if (!tags.length) {
    return null;
  }

  return (
    <Overlay data-testid={dataTestId}>
      {tags.map((tag) => {
        const iconSrc = tag.image?.srcSmall || tag.image?.src;

        return (
          <Tooltip key={tag.id} title={tag.name} placement="top">
            {iconSrc ? (
              <TagIcon
                src={iconSrc}
                alt={tag.name}
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <TagBadge onClick={(e) => e.stopPropagation()}>
                {getTagShortLabel(tag.name)}
              </TagBadge>
            )}
          </Tooltip>
        );
      })}
    </Overlay>
  );
}
